import { render, staticRenderFns } from "./QueryProducts.vue?vue&type=template&id=035f9b34&"
import script from "./QueryProducts.vue?vue&type=script&lang=js&"
export * from "./QueryProducts.vue?vue&type=script&lang=js&"
import style0 from "./QueryProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QueryProducts.vue"
export default component.exports